import { TaskFormDataModel, TaskModel } from "../models";

export const mapTaskToFormData = (task: TaskModel) =>
  new TaskFormDataModel({
    Name: task.Name,
    Description: task.Description,
    StatusId: task.StatusId,
    TypeId: task.TypeId,
    PriorityId: task.PriorityId,
    DifficultyId: task.DifficultyId,
    Performers: task?.Performers || [],
    Observers: task?.Observers || [],
    PerformerIds: task.PerformerIds,
    ObserverIds: task.ObserverIds,
    Estimated: task.Estimated,
    DeadlineDate: task.DeadlineDate,
    Tags: task.Tags,
    SubtaskIds: task.SubtaskIds,
    Parent: task.Parent,
    FolderId: task.FolderId,
    Files: task.Files,
    WeeekTask: task.WeeekTask
  });
